import { REVISION } from "three";
var version = parseInt(REVISION.replace(/\D+/g, ""));
export { version };